<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">方案信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div class>
        <el-form ref="formref" :model="rowdata" label-width="100px">
          <el-form-item label="方案名称" prop="name" style="width: 400px;">
            <div class="divStyle">{{ rowdata.name }}</div>
          </el-form-item>
          <el-form-item label="流量方">
            <div class="divStyle">{{ rowdata.trafficOrgName }}</div>
          </el-form-item>
          <el-form-item label="生效时间" prop="startTime">
            <div class="divStyle">{{ rowdata.startTime }}至{{ rowdata.endTime ? rowdata.endTime : '永久' }}</div>
          </el-form-item>
          <el-form-item label="结算周期" prop="trafficDay">
            <div class="divStyle">{{ rowdata.trafficDay }}天</div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电站价格信息</span>
      </div>
      <div class>
        <!-- <div style="display:flex">
          <div style="width:100px;margin-right:20px;text-align:right;">价格类型</div>
          <div style="width:100px;">折扣价</div>
        </div> -->
        <div style="display:flex;margin-top:20px">
          <div style="width:100px;margin-right:20px;text-align: right;">价格设置</div>
          <div style="width:100px;">{{ electricityType }}</div>
          <div style="margin-left:20px;width:90px;">{{ electricity }}</div>
        </div>
        <div style="margin-top: 20px;display:flex;">
          <div style="margin-left:120px;width:100px;">{{ serviceFeeType }}</div>
          <div style="margin-left:20px;">{{ serviceFee }}</div>
        </div>
      </div>
    </el-card>
    <!-- <el-card>
            <div slot="header" class="clearfix">
                <span style="font-weight:600;color:#000">运营商费用信息</span>
            </div>
            <div class>
                <div style="display:flex">
                    <div style="width:150px;margin-left:50px;">运营商结算优惠</div>
                    <div style="margin-left:26px;width:100px;">{{electricityType}}</div>
                    <div style="margin-left:50px;width:90px;">{{electricity}}</div>
                </div>
                <div style="margin-top:20px;display:flex;">
                    <div style="margin-left:226px;width:100px;">{{serviceFeeType}}</div>
                    <div style="margin-left:50px">{{serviceFee}}</div>
                </div>
            </div>
        </el-card> -->
    <el-card shadow="never">
      <div slot="header">
        <span class="title">开放电站</span>
      </div>
      <el-form ref="form" :model="form" label-width="100px" style="width:100%;margin-top:20px;">
        <el-form-item label="提供方" prop="provider">
          <div class="divStyle">{{ rowdata.provider==0 ? '全平台直联' : (rowdata.provider == 1 ? '加盟直联' : '互联互通') }}</div>
        </el-form-item>
        <el-form-item label="选择运营商" prop="operatorOrgId">
          <STree v-model="rowdata.operatorOrgId" :data="operatorTree" style="width:400px;margin-top:10px;" :is-show-filter="false" />
        </el-form-item>
        <el-form-item label="选择电站">
          <STree v-model="form.target" :data="datatree" style="width:400px;margin-top:10px;" :is-show-filter="false" />
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {
  treeDisabled
} from '@/utils/tool'
export default {
  name: 'Liuliangfanganxiangqing',
  components: {},
  data() {
    return {
      id: '',
      // 方案信息
      rowdata: {},
      operatorTree: [],
      connectorId: '',
      electricityType: '',
      electricity: '',
      serviceFeeType: '',
      serviceFee: '',
      form: {},
      datatree: []
    }
  },
  computed: {},
  mounted() {
    // this.getPileTree();
    // 获取详情信息
    if (this.id) {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/business/traffic/getDataDetail',
        data: data,
        method: 'get',
        callback: (resp) => {
          this.rowdata = resp
          this.getOperator()
          if (resp.electricityType == 'fixed') {
            resp.electricity = this.getFloat(resp.electricity)
            this.electricity = resp.electricity + '元'
          } else {
            this.electricity = resp.electricity + '%'
          }
          this.electricityType = resp.electricityTypeValue
          this.serviceFeeType = resp.serviceFeeTypeValue

          if (resp.serviceFeeType == 'fixed') {
            resp.serviceFee = this.getFloat(resp.serviceFee)
            this.serviceFee = resp.serviceFee + '元'
          } else {
            this.serviceFee = resp.serviceFee + '%'
          }

          this.$store.dispatch('form/handle', {
            url: '/business/traffic/getTargetTree',
            data: {
              operatorId: this.rowdata.operatorOrgId
            },
            method: 'get',
            callback: resp => {
              this.datatree = treeDisabled(resp, true)
            }
          })
          this.rowdata.operatorOrgId = resp.operatorOrgId ? resp.operatorOrgId.split(',') : []
          this.form.target = resp.target ? resp.target.split(',') : []
        }
      })
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    },
    getPileTree() {
      const data = {

      }
      this.$store.dispatch('form/handle', {
        url: '/business/traffic/getTargetTree',
        method: 'get',
        callback: resp => {
          this.datatree = treeDisabled(resp, true)
          // for(var i=0;i<this.datatree.length;i++){
          //   this.datatree[i].disabled = true;
          //   let tem = this.datatree[i].children
          //   if(tem){
          //     for(var j=0;j<tem.length;j++){
          //       tem[j].disabled = true;
          //       let temp = tem.children
          //       if(temp){
          //         for(var k=0;k<temp.length;k++){
          //             temp[k].disabled = true;
          //         }
          //       }
          //     }
          //   }
          // }
        }
      })
    },
    getOperator() {
      const data = {
        attr: this.rowdata.provider
      }
      this.$store.dispatch('form/handle', {
        url: '/business/discountterm/getResponsibleOrgTree',
        data: data,
        method: 'get',
        callback: resp => {
          this.operatorTree = treeDisabled(resp, true)
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>



// WEBPACK FOOTER //
// src/views/flowScheme/flowSchemeDetail.vue